import { IOvertimeRule } from "../../../models"

export interface IOTPolicy {
    Id: string
    Name: string
    Type: EOTType
    OvertimeRules: IOvertimeRule[]
    Deleted: boolean
}

export enum EOTType {
    Weekly,
    Bi_Weekly
}